<template>
  <v-dialog v-model="dialog" max-width="500px">
    <v-card>
      <v-card-title class="headline">
        {{
          toEdit === null
            ? $t('create', { model: $tc('color', 1).toLowerCase() })
            : $t('edit')
        }}
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-container>
            <v-row>
              <v-col cols="12" class="pb-0">
                <v-text-field
                  v-model="form.name"
                  :rules="[(v) => !!v || $t('required')]"
                  :label="$t('name')"
                  outlined
                />
              </v-col>
              <v-col cols="12" class="pt-0 d-flex flex-column">
                <span class="mb-2 grey--text text--darken-2 font-weight-bold">
                  {{ $t('image') }}
                </span>
                <div v-if="previewImage" class="mb-3 d-flex justify-center">
                  <v-img
                    :src="previewImage"
                    max-width="100"
                    max-height="100"
                    class="rounded"
                  />
                </div>
                <v-file-input
                  v-model="form.image_path"
                  :rules="[(v) => !!v || !!previewImage || $t('required')]"
                  :label="$t('image')"
                  outlined
                  prepend-icon="fa-camera"
                  accept="image/*"
                  @change="onFileChange"
                  @click:clear="clearPreview"
                ></v-file-input>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="dialog = false">{{
          $t('cancel')
        }}</v-btn>
        <v-btn color="blue darken-1" text @click="save">{{
          $tc('save', 1)
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    toEdit: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      valid: false,
      previewImage: null,
      form: {
        name: '',
        image_path: null
      }
    }
  },
  computed: {
    dialog: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    ...mapGetters({
      company: 'company/getCompanyData'
    }),
    companyPk() {
      return this.company ? this.company.pk || this.company.id : null
    }
  },
  watch: {
    dialog(val) {
      if (val) {
        if (this.toEdit) {
          this.form = {
            name: this.toEdit.name,
            image_path: null
          }
          this.previewImage = this.toEdit.image_path || null
        } else {
          this.form = {
            name: '',
            image_path: null
          }
          this.previewImage = null
        }
        if (this.$refs.form) {
          this.$refs.form.resetValidation()
        }
      }
    }
  },
  methods: {
    onFileChange(file) {
      if (file) {
        this.previewImage = URL.createObjectURL(file)
      } else {
        this.previewImage = this.toEdit ? this.toEdit.image_path : null
      }
    },
    clearPreview() {
      this.previewImage = this.toEdit ? this.toEdit.image_path : null
    },
    async save() {
      if (this.$refs.form.validate()) {
        try {
          let formData = new FormData()
          formData.append('name', this.form.name)
          if (this.companyPk) formData.append('company_id', this.companyPk)
          if (this.form.image_path) {
            formData.append('image_path', this.form.image_path)
          }

          if (this.toEdit) {
            await this.$api.product.apparelcolor.edit({
              pk: this.toEdit.id,
              form: formData,
              opt: { skipErrorToast: true }
            })
            this.$toast.success(this.$t('saved'))
          } else {
            await this.$api.product.apparelcolor.create({
              form: formData,
              opt: { skipErrorToast: true }
            })
            this.$toast.success(this.$t('saved'))
          }
          this.$emit('done')
          this.dialog = false
        } catch (error) {
          console.error(error)
          if (error.response && error.response.data) {
            const data = error.response.data
            if (data.detail) {
              this.$toast.error(this.$t(data.detail) || data.detail)
            } else if (typeof data === 'object') {
              const firstKey = Object.keys(data)[0]
              const msg = Array.isArray(data[firstKey])
                ? data[firstKey][0]
                : data[firstKey]
              this.$toast.error(this.$t(msg) || msg)
            } else {
              this.$toast.error(this.$t('image_error_message'))
            }
          } else {
            this.$toast.error(this.$t('image_error_message'))
          }
        }
      }
    }
  }
}
</script>
